import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
const PhoneHelper = {
  validate: (phoneNumber: string) => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const PNF = PhoneNumberFormat;

    try {
      const number = phoneUtil.parse(phoneNumber, "SE");

      if (!phoneUtil.isValidNumber(number)) {
        return false;
      }

      const result = phoneUtil.format(number, PNF.E164);
      if (result === "") {
        return false;
      }

      return true;
    } catch {
      return false;
    }
  },
};

export default PhoneHelper;
